<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!--Header-->
              <div class="page_header">View CAPA Request</div>
              <!--Header-->
              <div class="page_main">
                <el-form
                  ref="form"
                  :model="info"
                  label-position="top"
                  class="request-form"
                >
                  <el-form-item label="CAPA ID" class="full-width-item">
                    <div class="gray-input">
                      {{ info.request_id || "/" }}
                    </div>
                  </el-form-item>
                  <div class="form-grid">
                    <!-- Left -->
                    <div class="form-col">
                      <el-form-item label="Status">
                        <div class="gray-input">
                          {{ info.status_name || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Priority">
                        <div class="gray-input">
                          <span v-if="info.priority == 1">High</span>
                          <span v-if="info.priority == 2">Medium</span>
                          <span v-if="info.priority == 3">Low</span>
                          <span v-if="!info.priority">/</span>
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigator">
                        <div class="gray-input">
                          {{ info.investigator || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                    <!-- Right -->
                    <div class="form-col">
                      <el-form-item label="Request Date">
                        <div class="gray-input">
                          {{ info.time1 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Acceptance Date">
                        <div class="gray-input">
                          {{ info.time2 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Start Date">
                        <div class="gray-input">
                          {{ info.time3 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Completion Date">
                        <div class="gray-input">
                          {{ info.time4 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Start Date">
                        <div class="gray-input">
                          {{ info.time5 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Completion Date">
                        <div class="gray-input">
                          {{ info.time6 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Close Date">
                        <div class="gray-input">
                          {{ info.pass_time || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="text-tip">CAPA Description</div>
                  <el-form-item
                    label="Description of the issue, concern, idea, or opportunity"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.description || "/" }}
                    </div>
                  </el-form-item>
                  <div class="text-tip">Background Information</div>
                  <div class="form-grid">
                    <!-- Left -->
                    <div class="form-col">
                      <el-form-item label="Requester">
                        <div class="gray-input">
                          {{ info.username || "/" }}
                        </div>
                      </el-form-item>
                      <!-- <el-form-item label="Company">
                        <div class="gray-input">
                          {{ info.company_name || "/" }}
                        </div>
                      </el-form-item> -->
                    </div>
                    <!-- Right -->
                    <div class="form-col">
                      <el-form-item label="Source Type">
                        <div class="gray-input">
                          {{ info.source_type || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Department">
                        <div class="gray-input">
                          {{ info.departments_name || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <el-form-item
                    label="Source Information"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.source_info || "/" }}
                    </div>
                  </el-form-item>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">CAPABackground Files</div>
                    </div>
                    <el-table
                      :data="backdocTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop="name"
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        Items affected by the issue, concern, idea, or
                        opportunity
                      </div>
                    </div>
                    <el-table
                      :data="affectArticleTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop=""
                        label="Item Type"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.article_type == 1">Document</div>
                          <div v-if="scope.row.article_type == 2">
                            Equipment
                          </div>
                          <div v-if="scope.row.article_type == 3">Product</div>
                          <div v-if="scope.row.article_type == 4">Tool</div>
                          <div v-if="scope.row.article_type == 5">Other</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="article_id"
                        label="ItemID"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_name"
                        label="Item Name"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_revision"
                        label="Item Revision"
                        min-width="140"
                        sortable
                      ></el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Serial Number"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.serial_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Batch Number"
                        min-width="160"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.lot_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Purchased Product?"
                        min-width="200"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.is_buy == 1">Yes</div>
                          <div v-if="scope.row.is_buy == 2">No</div>
                          <div v-else></div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Supplier"
                        min-width="200"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.supplier_name || "" }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Correction</div>
                    </div>
                    <el-table
                      :data="correctionTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop=""
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- Investigation Activity Log -->
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Investigation Activity Log</div>
                    </div>
                    <el-table
                      :data="investigationLogTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No activity log entries"
                    >
                      <el-table-column
                        prop="description"
                        label="Description"
                        min-width="260"
                        sortable
                      />
                      <el-table-column
                        prop=""
                        label="Created Time"
                        min-width="120"
                        sortable
                      >
                        <template #default="scope">
                          {{ initTime(scope.row.update_time) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Last Updated"
                        min-width="140"
                        sortable
                      >
                        <template #default="scope">
                          {{ initTime(scope.row.dateline) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="attachment"
                        label="Attachments"
                        min-width="160"
                      >
                        <template #default="scope">
                          <div
                            v-for="(value, index) in scope.row.filelist"
                            :key="index"
                            style="padding: 4px 0"
                          >
                            <a :href="value.url" target="_blank">{{
                              value.name
                            }}</a>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- Solution Plan -->
                  <div class="solution-plan">
                    <!-- Title Bar -->
                    <div class="plan-header">
                      <span class="plan-title">Solution Plan</span>
                      <el-button
                        type="text"
                        class="toggle-btn"
                        @click="toggleAll"
                      >
                        {{ allExpanded ? "Show Partial" : "Show All" }}
                        <i
                          :class="
                            allExpanded
                              ? 'el-icon-arrow-up'
                              : 'el-icon-arrow-down'
                          "
                        ></i>
                      </el-button>
                    </div>
                    <!-- Content Card -->
                    <div
                      class="plan-card"
                      v-for="(item, index) in rootCause"
                      :key="index"
                    >
                      <!-- Root Cause -->
                      <section class="plan-section">
                        <div class="plan-header">
                          <span class="plan-title">Root Cause</span>
                        </div>
                        <div class="form-block">
                          <el-form-item label="Root Cause Analysis Result">
                            <div class="gray-input">
                              {{ item.analysis_results }}
                            </div>
                          </el-form-item>
                        </div>
                        <template
                          v-if="rootCauseExpanded == item.id || allExpanded"
                        >
                          <div class="form-grid">
                            <!-- Left -->
                            <div class="form-col">
                              <el-form-item
                                label="Is this root cause related to the supplier??"
                              >
                                <div class="gray-input">
                                  {{ item.is_supplier == 1 ? "Yes" : "No" }}
                                </div>
                              </el-form-item>
                            </div>
                            <!-- Right -->
                            <div class="form-col">
                              <el-form-item label="Root Cause Supplier">
                                <div class="gray-input">
                                  {{ item.supplier_name }}
                                </div>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="custom-panel">
                            <div class="panel-header">
                              <div class="table-title">
                                Root Cause Analysis Files
                              </div>
                            </div>
                            <el-table
                              :data="item.filelist"
                              border
                              stripe
                              header-cell-class-name="table-header-cell"
                              class="file-table"
                              empty-text="No root cause analysis files"
                            >
                              <el-table-column
                                prop=""
                                label="Description"
                                sortablemin-width="200"
                              >
                                <template slot-scope="scope">
                                  <div>{{ scope.row.description || "/" }}</div>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="fileName"
                                label="File Name"
                                min-width="240"
                              >
                                <template slot-scope="scope">
                                  <a :href="scope.row.url" target="_blank">{{
                                    scope.row.name
                                  }}</a>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </template>
                        <div v-if="!allExpanded" class="section-toggle">
                          <el-button
                            type="text"
                            @click="rootCauseExpandedClick(item)"
                          >
                            {{
                              rootCauseExpanded == item.id || allExpanded
                                ? "Collapse"
                                : "Expand"
                            }}
                            <i
                              :class="
                                rootCauseExpanded == item.id || allExpanded
                                  ? 'el-icon-arrow-up'
                                  : 'el-icon-arrow-down'
                              "
                            ></i>
                          </el-button>
                        </div>
                      </section>
                      <!-- Divider -->
                      <div class="divider"></div>
                      <!-- Corrective Actions -->
                      <div
                        class="plan-card"
                        v-for="(item2, index2) in item.caparootcauseaction_list"
                        :key="index2"
                        style="padding-left: 30px"
                      >
                        <section class="plan-section">
                          <div class="plan-header">
                            <span class="plan-title">{{
                              item2.capa_type == 1
                                ? "Corrective Actions"
                                : "Preventive Actions"
                            }}</span>
                          </div>
                          <div class="form-block">
                            <el-form-item
                              label="Action Implementation Description"
                            >
                              <div class="gray-input">
                                {{ item2.implementation_instructions }}
                              </div>
                            </el-form-item>
                          </div>
                          <template
                            v-if="correctiveExpanded == item2.id || allExpanded"
                          >
                            <div class="form-block">
                              <el-form-item label="Implementer">
                                <div class="gray-input">
                                  {{ item2.implementor_username }}
                                </div>
                              </el-form-item>
                            </div>
                            <div class="form-block">
                              <el-form-item label="Planned Action Due Date">
                                <div class="gray-input">
                                  {{ initTime2(item2.end_time) }}
                                </div>
                              </el-form-item>
                            </div>
                            <div class="custom-panel">
                              <div class="panel-header">
                                <div class="table-title">Affected Files</div>
                              </div>
                              <el-table
                                :data="item2.filelist"
                                border
                                stripe
                                header-cell-class-name="table-header-cell"
                                class="file-table"
                                empty-text="No affected files"
                              >
                                <el-table-column
                                  prop=""
                                  label="Description"
                                  sortable
                                  min-width="200"
                                >
                                  <template slot-scope="scope">
                                    <div>
                                      {{ scope.row.description || "/" }}
                                    </div>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="fileName"
                                  label="File Name"
                                  min-width="240"
                                >
                                  <template slot-scope="scope">
                                    <a :href="scope.row.url" target="_blank">{{
                                      scope.row.name
                                    }}</a>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <div class="form-block" style="margin-top: 20px">
                              <el-form-item
                                label="Operational Verification Description"
                              >
                                <div class="gray-input">
                                  {{ item2.verification_instructions }}
                                </div>
                              </el-form-item>
                            </div>
                          </template>
                          <div v-if="!allExpanded" class="section-toggle">
                            <el-button
                              type="text"
                              @click="correctiveExpandedClick(item2)"
                            >
                              {{
                                correctiveExpanded == item2.id || allExpanded
                                  ? "Collapse"
                                  : "Expand"
                              }}
                              <i
                                :class="
                                  correctiveExpanded == item2.id || allExpanded
                                    ? 'el-icon-arrow-up'
                                    : 'el-icon-arrow-down'
                                "
                              ></i>
                            </el-button>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                  <!-- Impact of the Solution -->
                  <div class="section-block">
                    <div class="text-tip">Impact of the Solution</div>
                    <el-form-item label="Affect Files?">
                      <div class="gray-input">
                        <span v-if="info.impacts_documents == 1">Yes</span>
                        <span v-if="info.impacts_documents == 2">No</span>
                      </div>
                    </el-form-item>
                    <el-form-item label="Affect Production Output?">
                      <div class="gray-input">
                        <span v-if="info.impacts_product == 1">Yes</span>
                        <span v-if="info.impacts_product == 2">No</span>
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="Description of the Impact on Production Output"
                    >
                      <div class="gray-input">
                        {{ info.impacts_description || "/" }}
                      </div>
                    </el-form-item>
                    <el-form-item label="Change Authorization Requirements">
                      <div class="gray-input">
                        {{ info.change_auth || "/" }}
                      </div>
                    </el-form-item>
                  </div>
                  <!-- CAPAEffectiveness Verification Plan -->
                  <div class="section-block">
                    <div class="text-tip">
                      CAPAEffectiveness Verification Plan
                    </div>
                    <el-form-item
                      label="This  CAPA request requires  CAPA effectiveness verification?"
                    >
                      <div class="gray-input">
                        <span v-if="info.capa_verification == 1">Yes</span>
                        <span v-if="info.capa_verification == 2">No</span>
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="CAPAEffectiveness Verification Description"
                    >
                      <div class="gray-input">
                        {{ info.capa_instructions }}
                      </div>
                    </el-form-item>
                    <el-form-item label="CAPAVerification Plan Assignee">
                      <div class="gray-input">
                        {{ info.capa_instructions_username }}
                      </div>
                    </el-form-item>
                    <el-form-item label="CAPAVerification Plan Due Date">
                      <div class="gray-input">
                        {{ info.capa_instructions_endtime }}
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="Not Required CAPA Reason Verification Is Not Required"
                    >
                      <div class="gray-input">
                        {{ info.nocapa_reason }}
                      </div>
                    </el-form-item>
                  </div>
                  <!-- StartCAPA Shown After Verification -->
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">CAPA Verification Files</div>
                    </div>
                    <el-table
                      :data="validationTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop=""
                        label="Description"
                        sortable
                        min-width="200"
                      >
                        <template slot-scope="scope">
                          <div>{{ scope.row.description || "/" }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="fileName"
                        label="File Name"
                        min-width="240"
                      >
                        <template slot-scope="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="custom-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        CAPA Verification Task History
                      </div>
                    </div>
                    <el-table
                      :data="validaHistoryList"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop="task"
                        label="Additional Notes"
                        sortable
                      />
                      <el-table-column
                        prop="status"
                        label="Task Status/Result"
                        sortable
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.status == 1">In Progress</div>
                          <div v-if="scope.row.status == 2">Approve</div>
                          <div v-if="scope.row.status == 3">Reject</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="remark"
                        label="Comments"
                        sortable
                      />
                      <el-table-column
                        prop="apply_username"
                        label="Task Owner"
                        sortable
                      />
                      <el-table-column
                        prop="end_time"
                        label="Task Due Date"
                        sortable
                      />
                    </el-table>
                  </div>
                  <!-- StartCAPA Shown After Verification -->
                  <!-- Task History -->
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Task History</div>
                      <el-input
                        v-model="keyword"
                        placeholder="Search"
                        clearable
                        class="search-input"
                      >
                        <i
                          slot="prefix"
                          class="el-input__icon el-icon-search"
                        ></i>
                      </el-input>
                    </div>
                    <el-table
                      :data="historyTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop="step_name"
                        label="Task Name"
                        sortable
                        min-width="160"
                      />
                      <el-table-column
                        prop="request_id"
                        label="Product Details"
                        sortable
                        min-width="170"
                      />
                      <!-- <el-table-column
                        prop="company_name"
                        label="Representing Company"
                        sortable
                        min-width="210"
                      /> -->
                      <el-table-column
                        prop="departments_name"
                        label="Representing Department"
                        sortable
                        min-width="220"
                      />
                      <el-table-column
                        prop=""
                        label="Task Status/Result"
                        sortable
                        min-width="180"
                      >
                        <template slot-scope="scope">
                          <div>
                            {{
                              getStatusText(
                                scope.row.flow_leixing,
                                scope.row.status
                              )
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Comments"
                        sortable
                        min-width="160"
                      >
                        <template slot-scope="scope">
                          <div>{{ scope.row.remark || "/" }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="apply_username"
                        label="Task Owner"
                        sortable
                        min-width="200"
                      />
                      <el-table-column
                        prop="end_time"
                        label="Task Due Date"
                        sortable
                        min-width="160"
                      />
                      <el-table-column
                        prop="app_time"
                        label="Completion Date"
                        sortable
                        min-width="160"
                      />
                    </el-table>
                    <div class="pagination">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handlePageChange"
                        :current-page="page"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="page_size"
                        layout="total, sizes, prev, pager, next"
                        :total="pageTotal"
                      >
                      </el-pagination>
                    </div>
                  </div>
                  <!-- Bottom Buttons -->
                  <div class="footer-actions">
                    <el-button type="primary" size="small" @click="handleClose">
                      Close
                    </el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { capaRequestDetail } from "@/api/capaManage/capaSearch/index";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from "moment";
export default {
  name: "CapaDetail",
  components: {
    headers,
    slider,
  },
  data() {
    return {
      keyword: "",
      showSolution: true,
      rootCauseExpanded: null,
      correctiveExpanded: null,
      allExpanded: false,
      info: {},
      backdocTableData: [],
      affectArticleTableData: [],
      correctionTableData: [],
      investigationLogTableData: [],
      rootCauseFiles: [],
      affectedFiles: [],
      verifyFiles: [],
      validationTableData: [],
      validaHistoryList: [],
      taskList: [],
      historyTableData: [],
      rootCause: [],
      page: 1,
      page_size: 10,
      pageTotal: 0,
    };
  },
  mounted() {
    let that = this;
    that.getDetail();
  },
  methods: {
    getDetail() {
      let that = this;
      capaRequestDetail({
        id: that.$route.query.oid,
        page: that.page,
        page_size: that.page_size,
      }).then((res) => {
        if (res.code == 200) {
          that.info = {
            ...that.info,
            id: res.data.id,
            request_id: res.data.request_id,
            status_name: res.data.status_name,
            priority: res.data.priority,
            investigator: res.data.investigator,
            description: res.data.description,
            username: res.data.username,
            // company_name: res.data.company_name,
            source_type: res.data.source_type,
            departments_name: res.data.departments_name,
            source_info: res.data.source_info,
            time1: res.data.time1,
            time2: res.data.time2,
            time3: res.data.time3,
            time4: res.data.time4,
            time5: res.data.time5,
            time6: res.data.time6,
            pass_time: res.data.pass_time,
            step_name: res.data.step_name,
            verfity_num: res.data.verfity_num,
            impacts_documents: res.data.impacts_documents,
            impacts_product: res.data.Impacts_product,
            impacts_description: res.data.Impacts_description,
            change_auth: res.data.change_auth,
            capa_verification: res.data.capa_verification,
            capa_instructions: res.data.capa_instructions,
            capa_instructions_endtime: that.initTime2(
              res.data.capa_instructions_endtime
            ),
            capa_instructions_username: res.data.capa_instructions_username,
            nocapa_reason: res.data.nocapa_reason,
            capa_instructions_uid: res.data.capa_instructions_uid,
          };
          that.backdocTableData = res.data.capabackground_list || [];
          that.correctionTableData = res.data.capacorrections_list || [];
          that.affectArticleTableData = res.data.capaarticle_list || [];
          that.investigationLogTableData = res.data.capaaffected_list || [];
          that.rootCause = res.data.caparootcause_list || [];
          that.validationTableData =
            res.data.capa_verification_results_list || [];
          that.validaHistoryList = res.data.capa_verification_apply_list || [];
          // Task History Pagination
          that.historyTableData = res.data.apply_list.data || [];
          that.pageTotal = res.data.apply_list.total || 0;
          that.page = res.data.apply_list.current_page || that.page;
          that.page_size =
            Number(res.data.apply_list.per_page) || that.page_size;
        }
      });
    },
    //Initialize Time
    initTime(value) {
      if (value) {
        return moment(value * 1000).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "/";
      }
    },
    //Initialize Time
    initTime2(value) {
      if (value) {
        return moment(value * 1000).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },
    //Page Size Selection
    handleSizeChange(value) {
      let that = this;
      that.page_size = value;
      that.getDetail();
    },
    //Page Navigation
    handlePageChange(value) {
      let that = this;
      that.page = value;
      that.getDetail();
    },
    handleClose() {
      window.close();
    },
    // Status Mapping
    getStatusText(flow_leixing, status) {
      if (flow_leixing == 1) {
        let map = {
          1: "In Progress",
          2: "Approve",
          3: "Reject",
          4: "Auto Rejected",
          9: "Withdrawn",
        };
        return map[status] || "";
      } else {
        let map = {
          1: "Unread",
          2: "Read",
        };
        return map[status] || "";
      }
    },
    //Expand & Hide All
    toggleAll() {
      let that = this;
      that.allExpanded = !that.allExpanded;
      if (!that.allExpanded) {
        that.rootCauseExpanded = null;
        that.correctiveExpanded = null;
      }
    },
    //Expand & Hide
    rootCauseExpandedClick(value) {
      let that = this;
      if (that.rootCauseExpanded == value.id) {
        that.rootCauseExpanded = null;
      } else {
        that.rootCauseExpanded = value.id;
      }
    },
    correctiveExpandedClick(value) {
      let that = this;
      if (that.correctiveExpanded == value.id) {
        that.correctiveExpanded = null;
      } else {
        that.correctiveExpanded = value.id;
      }
    },
    viewTask(row) {
      console.log("View Task: ", row);
    },
  },
};
</script>


<style lang="less" scoped>
//Main Content
.main_main {
  .page_main {
    padding: 18px 20px;

    .btn_el {
      margin: 10px 0 20px 0;

      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  //Header
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>

<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label Style */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* Unified Input Style */
.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.text-tip {
  background-color: #fafafa;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.file-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 40px;
}

.custom-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.search-input {
  width: 220px;
}

.file-table {
  width: 100%;
  margin-top: 8px;
}

.solution-plan {
  width: 100%;
  color: #303133;
  font-size: 13px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.plan-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.plan-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  margin-right: 8px;
}

.toggle-btn {
  padding: 0;
  font-size: 13px;
}

.plan-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}

.plan-section {
  padding: 28px 20px 18px;
}

.section-title {
  margin: 0 0 26px;
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.sub-title {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 20px;
}

.form-block {
  margin-bottom: 10px;
}

.field-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #303133;
}

.section-toggle {
  margin-top: 12px;
}

.section-toggle .el-button {
  padding: 0;
  font-size: 14px;
  font-weight: 600;
}

.divider {
  height: 1px;
  background: #ebeef5;
}

.el-icon-arrow-down,
.el-icon-arrow-up {
  margin-left: 2px;
}

.footer-actions {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-self: center;
}

.flow-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.flow-wrapper {
  position: relative;
  width: 1220px;
  height: 180px;
  margin: 0 auto;
}

.flow-svg {
  position: absolute;
  left: 0;
  top: 0;
  width: 1220px;
  height: 180px;
  z-index: 1;
  overflow: visible;
}

.flow-line {
  fill: none;
  stroke: #333;
  stroke-width: 1.2;
}

.flow-node {
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  background: #f6f7fb;
  border: 1px solid #9a82ff;
  color: #111;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-submit {
  left: 170px;
  top: 60px;
  width: 90px;
  height: 60px;
}

.node-hold {
  left: 385px;
  top: 18px;
  width: 90px;
  height: 56px;
}

.node-approve {
  left: 390px;
  top: 102px;
  width: 88px;
  height: 76px;
}

.node-investigate {
  left: 560px;
  top: 60px;
  width: 90px;
  height: 60px;
}

.node-plan {
  left: 690px;
  top: 72px;
  width: 90px;
  height: 36px;
}

.node-current {
  left: 820px;
  top: 60px;
  width: 105px;
  height: 60px;
  background: #005baa;
  border-color: #9a82ff;
  color: #fff;
}

.node-capa {
  left: 965px;
  top: 48px;
  width: 90px;
  height: 84px;
}

.node-closed {
  left: 1090px;
  top: 72px;
  width: 55px;
  height: 36px;
}

.pagination {
  margin: 10px 0;
  text-align: right;
}
</style>